import styled from "styled-components"
import {Grid as GridBase, Row, Col} from "react-bootstrap"

import {greys} from "@irati/ui/src/global/colors"
import media, {minWidthMedia} from "@irati/ui/src/global/media"
import IconBase from "@irati/ui/src/Icon"
import Card from "@irati/ui/src/Layout/Card"

export {default as Button} from "./Button"
export {default as Card} from "./Card"

export const TitleContainer = styled(Col).attrs({md: 12})`
  display: flex;
  justify-content: space-between;
`

export const CardHeader = styled(Row)`
  margin-bottom: 15px;
`

export const FlexRow = styled.div`
  display: flex;
  .form-group {
    width: 100%;
  }
  .col-xs-12 {
    padding: 0px;
  }
`

export const Grid = styled(GridBase)`
  margin-top: -200px;
`

interface RewardThumbnailProps {
  leftMargin?: boolean
}

export const RewardThumbnail = styled.img<RewardThumbnailProps>`
  background-color: ${greys.white};
  border-radius: 5px;
  box-shadow: 0 0 3px 0 rgba(61,61,54,0.2), 0 3px 2px 2px rgba(61,61,54,0.15);
  height: 60px;
  max-width: none;
  width: 60px;
  ${({leftMargin}) => (leftMargin && "margin-left: 15px;")}

  ${minWidthMedia.tablet`
    height: 90px;
    width: 90px;
  `}
`

export const SummaryRow = styled.div`
  display: flex;
  word-break: break-word;
  margin-bottom: 15px;
`

export const InputWrapper = styled(Row)`
  margin-bottom: 15px;
`

export const RowContent = styled.div`
  max-width: 260px;
`

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Hr = styled.hr`
  margin: 0 0 15px 0;
`

export const Icon = styled(IconBase)`
  margin-right: 5px;
`

export const Summary = styled(Card)`
  ${media.tablet`margin-top: 15px;`}
`

export const SummaryButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
  button {
    width: 50%;
    line-height: 15px;
    font-size: 14px;
    &:nth-child(2) {
      margin-left: 15px;
    }
  }
`

export const H4 = styled.h4`
  margin-bottom: 15px;
`
